import { render, staticRenderFns } from "./tarif-admissions.html?vue&type=template&id=27c87e70&scoped=true&external"
import script from "./tarif-admissions.js?vue&type=script&lang=js&external"
export * from "./tarif-admissions.js?vue&type=script&lang=js&external"
import style0 from "./tarif-admissions.scss?vue&type=style&index=0&id=27c87e70&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c87e70",
  null
  
)

export default component.exports